<template>
  <footer class="w-full max-display pb-32">
    <a href="https://shoreditchdesignstudio.com/"
        class=" w-full cursor-pointer flex justify-center flex-col mt-10">
      <div class="w-full flex justify-center mb-1">
        <footer-logo-svg />
      </div>
      <div class="w-full flex justify-center">
        <span
          class="text-sm font-medium "
          :class="[textColor ? 'text-white' : 'text-regal-gray']"
        >
          Made by Shoreditch Design Studio
        </span>
      </div>
    </a>
  </footer>
</template>
<script>
import FooterLogoSvg from "@/components/Footer/FooterLogoSvg";

export default {
  name: "XFooter",
  components: { FooterLogoSvg },
  props: {
    textColor: {
      type: Boolean
    }
  }
};
</script>
